module.exports = __webpack_public_path__ + "static/img/frightener.070aa97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/frightener.png
// module id = XL7/
// module chunks = 0